import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import OtpVerification from "../auth/forms/OtpVerification"

export default function OtpWrapper(props) {

    return (
        <>
            <UiAuthContainer >
                <div className="sb-auth-top-wr">
                    <h2>Otp Verification</h2>
                    <div className='sba-auth-top-heading'>
                        <h5>Please enter the OTP sent to your registered mobile & email</h5>
                    </div>
                    <OtpVerification />
                    <UiAuthFooterContainer/>
                </div>
            </UiAuthContainer>

        </>
    );
}
